import React from 'react';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/system/styleFunctionSx/styleFunctionSx';
import LoginMenu from './LoginMenu';

let appBarProps: SxProps = {
  zIndex: 2,
  p: 0,
  display: 'flex',
  background: "linear-gradient(to bottom, #0E303A, #0E303A, #0E303A )",
};

let appIconButtonProps: SxProps = {
  borderRadius: 0,
  m: 0,
  ml: "0px",
  pl: "4px",
  height: "42px",
  maxHeight: "42px"
};

let appIconImageProps: SxProps = {
  borderRadius: 0,
  ml: "8px",
  mr: "12px",
  width: "32px",
  height: "30px"
};

let appTitleProps: SxProps = {
  ml: "8px",
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: "auto",
  pt: "0px",
  fontSize: "15px",
};

const Banner = () => {
  return (
    <AppBar position="static" sx={appBarProps}>
      <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', height: '100%' }}>
      <IconButton edge="start" color="inherit" aria-label="menu" sx={appIconButtonProps} >
          <Box sx={{ ...appIconImageProps, width: "24px", height: "24px" }}>
            <img src="/navicon.svg" alt="nav icon" />
          </Box>
          <img src="/logotype-2.svg" alt="logo" />
          <Typography variant="h5" flexGrow={0} sx={appTitleProps} >| Supply Chain Intelligence</Typography>
        </IconButton>
        <LoginMenu />
      </Box>
    </AppBar>
  );
}

export default Banner;